import { createProductSlider,changeProductVariant,changeSwymIconPlace } from './custom-library.js';

var html_from_wp = document.createElement('div');
    
const bodyNode = document.querySelector('body');

// Added observer to monitor when the swym plugin loaded.
// And change swym icon place

if(bodyNode){
    function onSwymIsReady(e) {
        if(bodyNode.classList.contains('swym-ready')){
            changeSwymIconPlace();

            bodyObserver.disconnect();
        }
        
    }

    let bodyObserver = new MutationObserver(onSwymIsReady);

    bodyObserver.observe(bodyNode, {
        attributeFilter: ['class'],
    });
}




var addListenerForQuanitySelects = () => {

    const quantitySelects = document.querySelectorAll('.quantity-selector-select');

    if(quantitySelects?.length > 0){
        quantitySelects.forEach((select) => {
            const parentInput = select.parentElement.querySelector('input')

            if(parentInput && !parentInput.getAttribute('has-custom-listeners')){
                parentInput.setAttribute('has-custom-listeners',true);
                select.addEventListener("change",(e) => {
                    parentInput.value = e.target.value;

                    parentInput.focus();
                    parentInput.blur();
                })
                parentInput.addEventListener("change",(e) => {
                    select.value = e.target.value;
                })
                parentInput.addEventListener("cart-input:restore",(e) => {
                    select.value = e.detail.defaultValue;
                })
            }


        })
    }
};

function createMobileCategorieElement(collectionLink) {
    if (collectionLink) {
        
        const subCollections = collectionLink.parentElement.parentElement.querySelectorAll('.collection-accordion__inner a');
        if(subCollections?.length > 0) {
            const createWrapper = document.createElement('div');
            createWrapper.classList = 'mobile-sub-categories sub_categorie';
            createWrapper.setAttribute('data-id',collectionLink.getAttribute('data-id'));
            createWrapper.innerHTML = ` 
                <div class="mobile-categories__items-wrapper px-3">
                    <div
                        class="mobile-categories__title border-bottom border-gray-200 px-3 py-1 small fw-light gap-3 d-flex align-items-center justify-content-between"
                    >
                        ${collectionLink.textContent}
                    </div>
                    <ul class="categories-list">
                        ${[...subCollections].map((link) => {
                            link.classList = 'collection-links__link position-relative';

                            return `<li class="categories-list__item border-bottom border-gray-200">${link.outerHTML}</li>`
                        }).join('')}
                    </ul>
                </div>
            `

            return createWrapper;
        } else {
            return null;
        }
    } else {
        return null;
    }


}

function moveCollectionsInMobile() {
    // Move collections near filters in mobile
    
    const collectionsWrapper = document.querySelector('collection-links-component');
    const filtersMobileWrapper = document.querySelector('#filters-drawer .dialog-drawer');
    const collectionsExistInFilters = document.querySelector('#filters-drawer .mobile-categories') ? true : false;

    if(collectionsWrapper && filtersMobileWrapper && !collectionsExistInFilters){
        const cloneCollectionsWrapper = collectionsWrapper.cloneNode(true);
        const filtersMobile = filtersMobileWrapper.querySelector('.facets__form-wrapper');

        if(!filtersMobile) return;

        if(window.matchMedia("(max-width: 1300px)").matches){
            const categorieLabel = cloneCollectionsWrapper.getAttribute('collection-mobile-label');
            const collectionsLinks = cloneCollectionsWrapper.querySelectorAll('.collection-links__link');
            const activeCollection = cloneCollectionsWrapper.querySelector('.collection-links__link[aria-current-active="true"]');

            const newCollectionsLinks = [];

            const mobileCategoriesWrapper = document.createElement('div');
            mobileCategoriesWrapper.classList = 'mobile-categories mx-3 py-1 px-3 border-bottom';
            mobileCategoriesWrapper.innerHTML = `
                <div class="mobile-trigger">
                    <div class="mobile-trigger__wrapper">
                        <div class="mobile-trigger__label fw-bold text-blue">${categorieLabel}</div>
                        <div class="small text-gray-400 fw-normal active-categorie">${activeCollection?.textContent || ''}</div>
                    </div>
                </div>
                <div class="mobile-categories__items">
                    <div class="mobile-categories__items-wrapper px-3">
                        <div class="mobile-categories__title border-bottom border-gray-200 px-3 py-1 small fw-light gap-3 d-flex align-items-center justify-content-between">${categorieLabel}</div>
                        <ul class="categories-list">
                           ${[...collectionsLinks].map((link) => {

                            const activeSubcategory = link.parentElement.parentElement.querySelector('a[aria-current-active="true"]');

                            if(activeSubcategory){
                                link.setAttribute('aria-current-active',true);
                                link.setAttribute('aria-subcategory-active',true);

                            }

                            return `<li class="categories-list__item border-bottom border-gray-200">
                            <div class="categories-list__label">
                                ${link.outerHTML}
                                ${activeSubcategory ? `<div class="categories-list__subcategorie small fw-normal">${activeSubcategory.textContent}</div>` : ''}
                            </div>
                            ${link.getAttribute('data-has-subcollections') == 'true' ? '<div class="mobile-trigger sub-categorie"></div>' : ''}
                            </li>`
                        }).join('')}
                        </ul>
                    </div>
                </div>
            `
            // Add subcollections if exist

            collectionsLinks.forEach((collectionLink) => {
               const subCollectionWrapper =  createMobileCategorieElement(collectionLink);
               if(subCollectionWrapper) {
                filtersMobile.insertAdjacentElement('afterend', subCollectionWrapper);
               }
            })


            filtersMobile.insertAdjacentElement('afterend', mobileCategoriesWrapper);

            
            // Add listeners
            const mobileTrigger  = mobileCategoriesWrapper.querySelector('.mobile-trigger');
            const mobileSubTrigger  = document.querySelectorAll('.mobile-trigger.sub-categorie');

            const mobileCategoriesTitle = mobileCategoriesWrapper.querySelector('.mobile-categories__title');
            const mobileSubCategoriesTitle = document.querySelectorAll('.mobile-sub-categories .mobile-categories__title');

            mobileTrigger.addEventListener('click',() => {
                filtersMobileWrapper.classList.add('categories-submenu-active');
            })
            mobileCategoriesTitle.addEventListener('click',() => {
                filtersMobileWrapper.classList.remove('categories-submenu-active');
            })

            if(mobileSubTrigger?.length > 0 && mobileSubCategoriesTitle?.length > 0 ) {

                mobileSubTrigger.forEach(trigger => {
                    trigger.addEventListener('click',() => {
                        const collectionId = trigger.parentElement.querySelector('a').getAttribute('data-id');
                        const subCollectionWrapper = document.querySelector(`.mobile-sub-categories[data-id="${collectionId}"]`);
                        
                        subCollectionWrapper.classList.add('active');
                        filtersMobileWrapper.classList.add('sub-categories-submenu-active');
                    })
                });
                mobileSubCategoriesTitle.forEach(title => {
                    title.addEventListener('click',() => {
                        const collectionId = title.parentElement.querySelector('a').getAttribute('data-id');
                        const subCollectionWrapper = title.parentElement.parentElement;
                        
                        subCollectionWrapper.classList.remove('active');
                        filtersMobileWrapper.classList.remove('sub-categories-submenu-active');
                    })
                });

            }

            
        }
    }
}

function createOrderByButtons () {
    
    // Create order buttons 
    const applyFiltersButton = document.querySelector('#filters-drawer .facets__actions .facets__see-results');
    const sortingSelect = document.querySelector('#filters-drawer .sorting-filter__select');
    if (sortingSelect && sortingSelect.options.length > 0) {
        const container = document.createElement('div');
        container.className = 'd-flex gap-2 flex-wrap mobile-order-by';
        sortingSelect.after(container);
        sortingSelect.style.display = 'none';

        [...sortingSelect.options].forEach(option => {
            const button = document.createElement('button');

            button.type = 'button';
            button.textContent = option.textContent.trim();

            button.className = `
            text-nowrap
            text-lowercase
            btn-sm
            small
            Button
            btn
            d-inline-flex
            gap-2
            align-items-center
            justify-content-around
            ${option.selected ? 'btn-outline-primary' : 'btn-outline-gray-400'}
            `;

            button.dataset.value = option.value;

            button.addEventListener('click', () => {
                sortingSelect.value = option.value;

                // notificăm Shopify
                sortingSelect.dispatchEvent(new Event('change', { bubbles: true }));
                console.log(applyFiltersButton);
                
                applyFiltersButton?.click();
            });

            container.appendChild(button);
        });
    }

}



// Add container for menu
var header = document.querySelector('#header-component');
var menuContainer = document.createElement('div');
var activeMenu = null;
var timeuotIn = null;
var timeuotOut = null;
var headerNode = document.querySelector('header');
let headerObserver;


// Check when header-menu is changed and switching to the new version  

if(header) {
    headerObserver = new MutationObserver(() => {
        checkIfHeaderIsReplaced();
    });
    headerObserver.observe(header,  {
        childList: true,
        subtree: true
    });
}



function checkIfHeaderIsReplaced ()  {
    if(!header.querySelector('.desktop-menu')) {
        replaceHeader();
    }
}
function transformMenu(menu, addReverse, depth) {
    let menuLinks;

    // La adâncimea mai mică ca 2, luăm numai elementele din primu nivel
    // La adâncime mai mare luăm toate elementele
    if (depth < 2) {
        menuLinks = menu.children;
    } else {
        menuLinks = menu.querySelectorAll('li');
    }

    const newMenu = document.createElement('ul');
    newMenu.classList.add('custome-menu', `depth-${depth}`);

    for (let index = 0; index < menuLinks.length; index++) {
        const link = menuLinks[index];
        let newLink;
        // Get info
        const linkHref = link.querySelector('a')?.getAttribute('href');
        const linkTarget = link.querySelector('a')?.getAttribute('target');
        const linkContent = link.querySelector('.wp-block-navigation-item__label');

        // Create new element, and remove old classes
        // Lasăm numai clasele custom în menu-ul nou

        const newElement = document.createElement('li');
        const newClasses = [...link.classList].filter((item) => {
            const arrayDeleterClasses = [
                'wp-block-navigation-item',
                'wp-block-navigation-link',
                'has-child',
                'open-on-hover-click',
                'wp-block-navigation-submenu'
            ];
            if (arrayDeleterClasses.includes(item)) {
                return false;
            } else {
                return true;
            }
        });
        newElement.classList.add(...newClasses);

        if (linkContent && linkContent.textContent !== ' ') {
            newElement.innerHTML = `<a href="#" target="${linkTarget ? linkTarget : ''}"></a>`;
            newLink = newElement.querySelector('a');

            if (linkHref) {
                newLink.setAttribute('href', linkHref);
            } else {
                newLink.setAttribute('href', '#');
            }
            newLink.innerHTML = linkContent.innerHTML;
        }

        // Creăm sub menu numai pentru 2 nivele
        // Restu o să fie amplasate la nivelul numărul 2
        if (link.classList.contains('has-child') && depth < 2) {
            newElement.classList.add('has-child');
            newElement.appendChild(transformMenu(link.querySelector('ul'), addReverse, depth + 1));

            if (addReverse && newLink) {
                const reverseLink = newLink.cloneNode(true);
                const reverseElement = document.createElement('li');
                reverseElement.classList.add('reverse');
                reverseElement.appendChild(reverseLink);

                newElement.querySelector('ul').insertAdjacentElement('afterbegin', reverseElement);
            }
        }

        newMenu.appendChild(newElement);
    }

    return newMenu;
}
function clearTimeoutIn() {
    if (timeuotIn) {
        clearTimeout(timeuotIn);
        timeuotIn = null;
    }
}
function clearTimeoutOut() {
    if (timeuotOut) {
        clearTimeout(timeuotOut);
        timeuotOut = null;
    }
}
function openMenuContainer(newLink) {
    if (activeMenu == newLink) return;

    clearTimeoutIn();
    clearTimeoutOut();

    timeuotIn = setTimeout(() => {
        const innerMenu = newLink.querySelector('.custome-menu');
        activeMenu = newLink;
        menuContainer.innerHTML = '';
        menuContainer.classList.add('active');
        header.classList.add('active-menu');
        bodyNode.classList.add('active-menu');
        menuContainer.appendChild(innerMenu.cloneNode(true));
    }, 100);
}
function closeMenuContainer(event) {
    if (
        event.relatedTarget == menuContainer ||
        activeMenu?.contains(event.relatedTarget) ||
        event.relatedTarget == activeMenu
    )
        return;

    clearTimeoutIn();
    clearTimeoutOut();

    timeuotOut = setTimeout(() => {
        activeMenu = null;
        menuContainer.classList.remove('active');
        header.classList.remove('active-menu');
        bodyNode.classList.remove('active-menu');
    }, 100);
}
function replaceHeader (oldHeader) {
    // Add desktop nav
    const headerMobileMenu = document.querySelector('header .mobile-navigations-group');
    const oldHeaderNav = oldHeader ? oldHeader : document.querySelector('#header-component .header__column .header-menu');
    const announcementBarSlider =  document.querySelector('#header-group .announcement-bar .announcement-bar__slider');

    if(oldHeaderNav){
        const headerNav = document.createElement('nav');
        headerNav.setAttribute('ref','headerMenu');
        headerNav.classList.add('desktop-menu');
        let headerInnerNav = html_from_wp.querySelector('.header-desktop-navigation ul');

        if(headerInnerNav) {
            headerInnerNav = transformMenu(headerInnerNav, false, 0);
            headerNav.appendChild(headerInnerNav);

            oldHeaderNav.insertAdjacentElement('beforeBegin',headerNav);
            oldHeaderNav.remove();
        }

    }

    // Add mobile nav
    const mobileWrapperNavigation = document.querySelector('.mobile-wrapper__navigation');
    const oldHeaderMobileNav = document.querySelector('.menu-drawer__navigation');

    if(mobileWrapperNavigation && oldHeaderMobileNav) {
        const headerSocials = document.querySelector('.custom-socials');
        const menuExist = mobileWrapperNavigation.querySelector('.custome-menu');

        if(menuExist) return;

        let headerInnerNav = html_from_wp.querySelector('.mobile-navigations-group ul');

        if(headerInnerNav) {
            const newHeaderMenu = transformMenu(headerInnerNav, true, 0);
            
            mobileWrapperNavigation.appendChild(newHeaderMenu);

            if (headerSocials) {
                newHeaderMenu.appendChild(headerSocials.cloneNode(true));
            }

            // Change label for Sing In if is logged

            const signInLink = newHeaderMenu?.querySelector('.sign-in a');

            if(signInLink && bodyNode?.classList.contains('customer-active')) {
                signInLink.textContent = 'Account';
            }

            
        }
    }

    moveLanguageToMobile();

  


    // Add announcement bar

    if(announcementBarSlider){
        // const newTopHeader = document.createElement('div');
        // newTopHeader.classList.add('header-top');
        // newTopHeader.innerHTML = `
        //     <div class="col col-4 language-selector"><style>html[dir="rtl"] .wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu .wp-block-navigation-submenu__toggle img{margin-left:12px}html[dir="rtl"] .wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu ul.isHorizontal li{text-align:right}html[dir="rtl"] .wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu ul.isHorizontal li a img{margin-left:12px}.wpml-language-switcher-block{display:flex;box-sizing:border-box;width:100% !important}.wpml-language-switcher-block>.wp-block-navigation-item,.wpml-language-switcher-block>.wp-block-navigation-item>div{display:flex;width:100% !important}.wpml-language-switcher-block .wp-block-navigation__container{background:unset !important}.wpml-language-switcher-block .hide-arrow .wp-block-navigation__submenu-icon{display:none}.wpml-language-switcher-block .wpml-ls-dropdown ul li button{padding:0}.wpml-language-switcher-block .wpml-ls-dropdown ul li button+.isHorizontal{min-width:inherit !important}.wpml-language-switcher-block .wpml-ls-dropdown ul li button+.isHorizontal li{width:inherit !important}.wpml-language-switcher-block .wpml-ls-dropdown ul li button+.isHorizontal li a{display:flex;align-items:center;min-width:max-content}.wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu ul.isHorizontal{margin:0;min-width:inherit !important}.wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu ul.isHorizontal li{width:inherit !important;text-align:left}.wpml-language-switcher-block .wpml-ls-dropdown ul li.wp-block-navigation-submenu ul.isHorizontal li a{display:flex;align-items:center;min-width:max-content}.wpml-language-switcher-block ul{list-style-type:none !important;padding:0 !important;width:100%}.wpml-language-switcher-block ul li{margin:0}.wpml-language-switcher-block ul li>a.wp-block-navigation-item__content:focus{outline:1px solid #2F7D92}.wpml-language-switcher-block ul li.is-focused{outline:1px solid #2F7D92}.wpml-language-switcher-block ul.wp-block-navigation__submenu-container{border:inherit !important;background-color:unset !important;min-width:unset !important}.wpml-language-switcher-block ul.wp-block-navigation__submenu-container .wp-block-navigation-item{border-radius:0 !important}.wpml-language-switcher-block ul.wp-block-navigation__submenu-container .wp-block-navigation-item a{display:flex;align-items:center;min-width:max-content;padding:1px}.wpml-language-switcher-block ul.horizontal-list{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;margin:0 !important;gap:1em !important}.wpml-language-switcher-block ul.horizontal-list li{display:inline-block;margin:0;line-height:100%}.wpml-language-switcher-block ul.horizontal-list li a{line-height:100%}.wpml-language-switcher-block ul.center-justify{justify-content:center}.wpml-language-switcher-block ul.center-justify .wp-block-navigation-item{justify-content:center}.wpml-language-switcher-block ul.right-justify{justify-content:right}.wpml-language-switcher-block ul.right-justify .wp-block-navigation-item{justify-content:right}.wpml-language-switcher-block ul.space_between-justify{justify-content:space-between}.wpml-language-switcher-block ul.space_between-justify li>div{white-space:nowrap}.wpml-language-switcher-block .hasHoverColor:hover{color:var(--hover-color) !important}.wpml-language-switcher-block .hasHoverBackgroundColor:hover{background-color:var(--hover-background-color) !important}.wpml-language-switcher-block ul.isHorizontal{padding-left:0;list-style:none}.wpml-language-switcher-block ul.isHorizontal li{display:inline;margin-left:0}.wpml-language-switcher-block ul.isHorizontal li div{display:inline-block}.wpml-language-switcher-block ul.hasSpacing.isHorizontal li:not(:last-child){margin-right:var(--language-spacing) !important}.wpml-language-switcher-block ul.hasSpacing.isVertical li:not(:last-child){margin-bottom:var(--language-spacing) !important}.wpml-language-switcher-block ul.hasSpacing.isVertical .wp-block-navigation-item>div,.wpml-language-switcher-block ul.hasSpacing.isVertical .wp-block-navigation-item>div>a{display:inline-flex;align-items:center}.wpml-language-switcher-block .hasHoverColor:hover{color:var(--hover-color) !important}.wpml-language-switcher-block .hasHoverBackgroundColor:hover{background-color:var(--hover-background-color) !important}.wpml-language-switcher-block .hasFontSize{font-size:var(--font-size) !important}.wpml-language-switcher-block .hasLetterSpacing{letter-spacing:var(--letter-spacing) !important}.wpml-language-switcher-block .hasTextTransform{text-transform:var(--text-transform) !important}.wpml-language-switcher-block .hasFontFamily{font-family:var(--font-family) !important}.wpml-ls-flag{display:inline-block}.wpml-ls-flag-style-btn{border:0px transparent;padding-top:3px !important}.wpml-ls-flag-style-btn.black-bg{background-color:black}.wpml-ls-flag-style-btn.transparent-bg{background-color:transparent}.wpml-ls-control-row{border:solid 1px #949494;border-radius:2px;margin-bottom:8px}.wpml-ls-control-row-with-padding{padding:1px}.wpml-ls-number-control{max-width:100%;width:100%}.wpml-ls-slider-control-alert{margin-top:5px !important}.wpml-ls-slider .ant-slider-track{background-color:#3858E9}.wpml-ls-slider .ant-slider-handle{border:solid 1px black}.wpml-ls-control-blue{color:#2F7D92}.wpml-ls-number-with-unit-select select{color:#2F7D92;font-weight:700}.wpml-ls-control-grey{color:#757575}.wpml-ls-control-bg-grey{background-color:#a6a6a6}.wpml-ls-control-font{font-family:"SF Pro Text", sans-serif;font-style:normal;font-weight:400 !important;font-size:13px !important;line-height:140% !important}.wpml-ls-option-btn-col{padding:0.5px}.wpml-ls-no-borders{border:none}.ant-col-8.wpml-ls-option-btn-col{display:inline-flex}.wpml-ls-three-btn-row .wpml-ls-option-btn-wrap{padding-top:8px;padding-bottom:8px;white-space:normal;word-break:break-word}.wpml-ls-three-btn-row .ant-btn-no-height-less-padding{height:unset;padding-right:10px;padding-left:10px}.wpml-ls-full-width{width:100%}.wpml-ls-toggle-control .components-form-toggle.is-checked>.components-form-toggle__track{background-color:#2F7D92;border-color:#2F7D92}.wpml-ls-toggle-control .components-form-toggle.is-checked>.components-form-toggle__thumb{background-color:white}.wpml-ls-toggle-control .components-form-toggle>.components-form-toggle__track{background-color:white;border-color:#373737}.wpml-ls-toggle-control .components-form-toggle>.components-form-toggle__thumb{background-color:#373737}.ant-select-dropdown{min-width:45px !important;max-width:45px !important;width:45px !important}.wpml-ls-color-control{border:1px solid #DDDDDD;border-bottom:0px;padding:10px;box-sizing:border-box}.wpml-ls-color-control.wpml-ls-with-bottom-border{border-bottom:1px solid #DDDDDD}.wpml-ls-color-control .wpml-ls-icon-no-color:hover{cursor:pointer}.wpml-ls-color-control .component-color-indicator{width:25px;height:25px;box-shadow:0px 0px 2px 1px lightgrey}.wpml-ls-color-control .component-color-indicator:hover{cursor:pointer}.wpml-ls-color-control .wpml-ls-color-title{top:3px}.wpml-ls-dimension-control{border-top:solid 1px #e0e0e0}.wpml-ls-dimension-control .components-panel__arrow{visibility:hidden}.wpml-ls-panel-settings-dropdown-container{position:absolute;right:0px}.wpml-ls-icon-link{width:24px;height:24px;top:3px;border-radius:2px}.ant-input-number-handler-wrap{display:none !important}.ant-input-number-input{padding-right:0px !important;padding-left:3px !important}.block-editor-contrast-checker+.block-editor-contrast-checker{display:none}.current-language-item{display:flex;align-items:center;min-height:30px}.current-language-item .wp-block-navigation-item__content>div{display:flex;align-items:center}.wpml-ls-fontLetterCase-control button.components-button.has-icon{margin-right:0 !important;min-width:30px !important;height:30px !important}.wpml-ls-fontLetterSpacing-control div.components-input-control__container{top:4px}[data-wpml='language-item']:first-of-type{margin-top:5px !important}.wpml-ls-dimension-panel .components-panel__arrow{display:none}.wpml-ls-typography-panel .components-panel__arrow{display:none}.wpml-ls-panel-settings-dropdown-container>div>button>span.anticon-more{font-size:large;margin-right:10px}.wpml-ls-panel-settings-dropdown-container>div>button>span.anticon-plus{font-size:medium;margin-right:10px}.wpml-ls-color-panel .wpml-ls-color-panel-wrap button.components-button:focus{outline:2px solid #2F7D92;color:#2F7D92}.wpml-ls-color-panel .wpml-ls-color-panel-wrap button.components-button:hover{color:#2F7D92 !important}.wpml-ls-option-btn-wrap:focus{outline:4px solid #2F7D92}.wpml-ls-option-btn-wrap:hover:not(.wpml-ls-option-btn-wrap[data-selected="true"]){outline:2px solid #2F7D92;color:#2F7D92 !important}.wpml-ls-toggle-control .components-toggle-control__label:hover{color:#2F7D92}.components-input-control__container:hover .components-input-control__backdrop{border-color:#2F7D92 !important}input.components-input-control__input:focus ~ .components-input-control__backdrop{outline:2px solid #2F7D92 !important}.components-toggle-group-control[role="radiogroup"]:hover{border-color:#2F7D92}.components-toggle-group-control[role="radiogroup"] .components-toggle-group-control-option-base[role="radio"]:hover{color:#2F7D92}.components-toggle-group-control[role="radiogroup"] .components-toggle-group-control-option-base[role="radio"]:focus{color:#2F7D92;outline:2px solid #2F7D92}.ant-slider .ant-slider-handle:not(.ant-tooltip-open){background-color:#2F7D92 !important;border-color:#373737}.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open),.ant-slider .ant-slider-handle:focus{background-color:#373737 !important;border-color:#2F7D92}.wpml-ls-typography-panel .components-panel__body .ant-col{margin-bottom:12px}.wpml-ls-fontSize-control div[aria-label="Font size"]{margin-bottom:12px}.wpml-ls-fontSize-control .wpml-ls-fontLetterSpacing-control{display:grid;place-items:center;align-self:center}
        //         </style><div id="" class="wpml-language-switcher-block is-layout-flex is-responsive has-child-selected wp-block-navigation"><div class="block-editor-block-list__block wp-block wp-block-navigation-item has-link has-child wp-block-navigation-submenu"><div class="wpml-ls-dropdown open-on-hover-click "><ul class="wp-block-navigation__container"><li class="wp-block-navigation-item has-child wp-block-navigation-submenu open-on-hover-click"><div class="wp-block-navigation-item__content wp-block-navigation-submenu__toggle" aria-expanded="false"><span class="current-language-item" style="display:flex;cursor:pointer" data-wpml="current-language-item"><div style="display:inline-block" class="wp-block-navigation-item__content"><div><img decoding="async" alt="wpml-ls-flag" class="wpml-ls-flag" src="https://biscottigentilini.dev-onstep.it/wp-content/plugins/sitepress-multilingual-cms/res/flags/it.svg" style="margin-right:4px;width:18px;height:12px;border-radius:0%;object-fit:unset" size="24" width="24" height="24" data-wpml="flag-url"><span data-wpml="label" data-wpml-label-type="native" class="wp-block-navigation-item__label ">Italiano</span></div></div><span class="wp-block-navigation__submenu-icon"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false"><path d="M1.50002 4L6.00002 8L10.5 4" stroke-width="1.5"></path></svg></span></span></div><ul class="wp-block-navigation__submenu-container isHorizontal" style="flex-wrap:nowrap" data-is-drop-zone="true"></ul></li></ul></div></div></div>
        //     </div>

        //     <div class="swiper-top-info col col-4">
        //         <ul class="swiper-wrapper">
        //         <li class="swiper-slide">Iscriviti al Breakfast Club per la spedizione gratuita da 59,90 €</li>
        //         <li class="swiper-slide">Paga in 3 rate con Paypal</li>
        //         </ul>
        //     </div>

        //     <p class="col col-4 newsletter-link">Iscriviti al Breakfast Club!</p>
        // `  
        const newTopHeader = html_from_wp.querySelector('.header-top');

        if(newTopHeader) {
            announcementBarSlider.insertAdjacentElement('beforeBegin',newTopHeader);
            announcementBarSlider.remove();

            const headerTopInfo = document.querySelector('.swiper-top-info');
        
            if (headerTopInfo) {
                const headerTopSwiper = new Swiper(headerTopInfo, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    direction: 'vertical',
                    initialSlide: 2,
                    autoHeight: true,
                    autoplay: {
                        delay: 2500
                    }
                });
            }
        }

    }

    // Add events desktop menu
    const newLinksDepth0 = document.querySelectorAll('.desktop-menu .custome-menu.depth-0 > .has-child');

    if (newLinksDepth0?.length > 0) {
        newLinksDepth0.forEach((newLink) => {
            newLink.addEventListener('click', (e) => e.preventDefault());
            newLink.addEventListener('mouseenter', () => openMenuContainer(newLink));
            newLink.addEventListener('mouseleave', closeMenuContainer);
        });
    }

    // Add events mobile menu

    const mobileOpeners = document.querySelectorAll('.mobile-menu .has-child');
    const mobileClosers = document.querySelectorAll('.mobile-menu .has-child .reverse');
    const mobileMenus = document.querySelectorAll('.mobile-menu .has-child ul');

    if (mobileOpeners?.length > 0 && mobileClosers?.length > 0 && mobileMenus?.length > 0) {
        
        mobileOpeners.forEach((opener) => {
            opener.addEventListener('click', (e) => {
                e.preventDefault();
                const menuList = opener.querySelector('ul');
                const menuParent = opener.parentElement;

                menuParent.classList.add('previous');
                menuList.classList.add('active');
            });
        });
        mobileClosers.forEach((closer) => {
            closer.addEventListener('click', (e) => {
                e.preventDefault();
                const menuParent = closer.parentElement;
                const previousOpenedMenu = closer.parentElement?.parentElement?.parentElement;
                if (previousOpenedMenu) {
                    previousOpenedMenu.classList.remove('previous');
                }
                menuParent.classList.remove('active');
            });
        });

        mobileMenus.forEach((list) => {
            list.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        });
    }

    // Add container for menu
    if(!document.querySelector('.menu-container')) {
        menuContainer = document.createElement('div');
        menuContainer.classList.add('menu-container', 'py-5');
        header.appendChild(menuContainer);
        menuContainer.addEventListener('mouseleave', closeMenuContainer);
    }

}



function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}

async function moveLanguageToMobile() {
    const languageSelectorButton = document.querySelector('.language-selector__button');
    const languageSelectorModal = document.querySelector('.language-selector__modal');
    const socialsMobile = document.querySelector('.mobile-wrapper__navigation .custom-socials');

    
    if (socialsMobile && languageSelectorButton && languageSelectorModal) {
        const oldLanguageButton = document.querySelector('.mobile-wrapper__navigation .language-selector__button');
        const oldLanguageModal = document.querySelector('.mobile-wrapper__navigation .language-selector__modal');

        if(oldLanguageButton && oldLanguageModal){
          await oldLanguageButton.remove();
          await oldLanguageModal.remove();
        }

        const copyLanguageSelectorButton = languageSelectorButton.cloneNode(true);
        const copyLanguageSelectorModal = languageSelectorModal.cloneNode(true);
        
        socialsMobile.insertAdjacentElement('beforebegin', copyLanguageSelectorButton);
        socialsMobile.insertAdjacentElement('beforebegin', copyLanguageSelectorModal);

        copyLanguageSelectorButton.addEventListener('click', () => {
            const parentElement = copyLanguageSelectorButton.parentElement;
            
            if (parentElement.classList.contains('previous')) {
                parentElement.classList.remove('previous');
                copyLanguageSelectorModal.classList.remove('active');

            } else {
                parentElement.classList.add('previous');
                copyLanguageSelectorModal.classList.add('active');

            }
        });


        const previousModal = copyLanguageSelectorModal.querySelector('.previous-mobile');
        const mobileLanguageSelectorSubmit = copyLanguageSelectorModal.querySelector('.language-selector__modal .btn[type="submit"]');
        const gtSwitcherSelected = copyLanguageSelectorModal.querySelector('.gt_selected');
        const gtSwitcherOptions = copyLanguageSelectorModal.querySelector('.gt_option');
        if (previousModal && mobileLanguageSelectorSubmit) {
            function closeLanguageModal() {
                const mobileMenu = document.querySelector('.mobile-wrapper__navigation .custome-menu');
                mobileMenu?.classList.remove('previous');
                copyLanguageSelectorModal.classList.remove('active');
            }
            previousModal.addEventListener('click', closeLanguageModal);
            mobileLanguageSelectorSubmit.addEventListener('click', closeLanguageModal);
        }

        if(gtSwitcherSelected && gtSwitcherOptions && previousModal) {
            gtSwitcherSelected.addEventListener('click',() => {
                const linkSelected = gtSwitcherSelected.querySelector('a');
                linkSelected.classList.toggle('open');
                gtSwitcherOptions.classList.toggle('active');
            })

            const optionsLinks = gtSwitcherOptions.querySelectorAll('a');

            if(optionsLinks.length > 0) {
                optionsLinks.forEach((optionsLink) => {
                    optionsLink.addEventListener('click',() => {
                        const lang = optionsLink.getAttribute('data-gt-lang');
                        const realLangOption = document.querySelector(`#header-group a[data-gt-lang="${lang}"]`);
                        const selectedLang = copyLanguageSelectorModal.querySelector('.gt_selected a');

                        if(realLangOption) {
                            selectedLang.textContent = realLangOption.textContent;
                            realLangOption.click();
                            gtSwitcherSelected.click();
                            previousModal.click();
                        }
                        
                    })
                })
            }
        }

    }
}

function endloading(){ 
    document.getElementById('loadersite').style.opacity = 0; 
    document.getElementById('loadersite').style.visibility = "hidden";
    
}

document.addEventListener('DOMContentLoaded',async () => {


    async function loadHeaderAndFooterFromWP() {
        try {
        const response = await fetch(
        'https://www.biscottigentilini.it/wp-json/custom/v1/get-data-html',
            {
            method: 'GET'
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

            const html = await response.text();
            html_from_wp.innerHTML = html;
            
            console.info("DOMContentLoaded");
            endloading();

        } catch (error) {
            console.error('Error loading HTML:', error);
            console.info("DOMContentLoadedError");
            endloading();
        }

       const oldNewsletterContact = html_from_wp.querySelector('.sib-form');

       if(oldNewsletterContact) {
        oldNewsletterContact.remove();
       }
    }

    await loadHeaderAndFooterFromWP();



    // Copy header from WP
    replaceHeader();

    // Copy footer from WP
    const footer = document.createElement('footer');
    footer.classList.add('wp-block-template-part');

    if(html_from_wp.querySelector('footer')) {
        footer.innerHTML = html_from_wp.querySelector('footer')?.innerHTML;
        bodyNode.appendChild(footer);


        const footerMenuButtons = document.querySelectorAll('footer .footer-menu .wp-block-navigation-submenu__toggle');

        if(footerMenuButtons?.length > 0) {
            footerMenuButtons.forEach((menuButton) => {
                menuButton.addEventListener('click',() => {
                    if(menuButton.getAttribute('aria-expanded') == 'false'){
                        menuButton.setAttribute('aria-expanded',true);
                    }else{
                        menuButton.setAttribute('aria-expanded',false);
                    }
                })
            })
        }
    }


    // Copy behavior of quantity input to selector input

    addListenerForQuanitySelects();


    // Oberver to observ when cart modal is opening

    const cartModal = document.querySelector('cart-drawer-component dialog');

    if(cartModal){
        let observer = new MutationObserver(addListenerForQuanitySelects);

        observer.observe(cartModal, {
            attributeFilter: ['open'],
        });
    }


    const productVariants = document.querySelectorAll('.custom-product-variants');

    productVariants.forEach(element => {
        element.addEventListener('click',(e)=> {
            e.stopPropagation();
        })
    });


    // Create a wrapper for collection links and collection products
    // Move Collections In Mobile

    const collectionLinks = document.querySelector('collection-links-component')?.parentElement?.parentElement;
    const collectionProducts = document.querySelector('results-list')?.parentElement;

    if(collectionLinks && collectionProducts){
        const newWrapper = document.createElement('div');
        newWrapper.classList.add('container');
        newWrapper.innerHTML = `<div class="row"></div>`
        
        const wrapperRow = newWrapper.querySelector('div');

        collectionProducts.insertAdjacentElement("afterend", newWrapper);

        setTimeout(() => {
            // Add stylin for elements
            collectionLinks.classList.add('col','col-12','col-lg-3','collections-links-custom');
            wrapperRow.appendChild(collectionLinks);
            collectionProducts.classList.add('col','col-12','col-lg-9','products-list-custom')
            wrapperRow.appendChild(collectionProducts);

            // Move Collections In Mobile
            window.addEventListener('resize', moveCollectionsInMobile);
            moveCollectionsInMobile();
        });
    }

    // Create Product Slider on mount
    createProductSlider()

    //Move breadcrumbs to product block

    const breadcrumbs = document.querySelector('.breadcrumbs-wrapper.product-breadcrumb');
    const productDetails = document.querySelector('.product-information__grid .product-details');
    if(breadcrumbs && productDetails){
        productDetails.insertAdjacentElement('afterbegin',breadcrumbs)
    }

    // Create ingredients slider

    const swipersIngredients = document.querySelectorAll('.swiper-ingredients');

    if(swipersIngredients){
        swipersIngredients.forEach((swiperIngredients) => {
            const sliderIngredients = new Swiper(swiperIngredients, {
                slidesPerView: 3,
                spaceBetween: 60,
            });
        })
    }

     // Create products box slider

    function setActiveBoxProduct () {
        const activeSliderID = document.querySelector('.products-slider__box .swiper-slide-active')?.getAttribute('data-id');
        
        if(activeSliderID) {
            const ingredientsItemActive = document.querySelector(`.ingredients__item.active`);
            const ingredientsItem = document.querySelector(`.ingredients__item[data-id="${activeSliderID}"]`);

            ingredientsItemActive?.classList.remove('active');
            ingredientsItem.classList.add('active');
        }
    }

    const swiperBox = document.querySelector('.products-slider__box');

    if(swiperBox){
        const navigationNext = swiperBox.querySelector('.swiper-button-next');
        const navigationPrev = swiperBox.querySelector('.swiper-button-prev');
    
        const sliderBox = new Swiper(swiperBox, {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
            centeredSlides: true,
            slideToClickedSlide:true,
            breakpoints: {
                575: {
                    slidesPerView: 4,
                },
                991: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 7
                }
            },
            navigation: {
                nextEl: navigationNext,
                prevEl: navigationPrev
            },
        });

        sliderBox.on('slideChange', setActiveBoxProduct);
    }

    const swiperRelatedProducts = document.querySelector('.related-swiper');
    
    if(swiperRelatedProducts) {
        const navigationNext = swiperRelatedProducts.querySelector('.swiper-button-next');
        const navigationPrev = swiperRelatedProducts.querySelector('.swiper-button-prev');

         const sliderRelatedProducts = new Swiper(swiperRelatedProducts, {
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: navigationNext,
                prevEl: navigationPrev
            },
        });
    }


    // Create Order Buttons

    createOrderByButtons();
    
    window.addEventListener('filter:updateCustom',() => {
        createOrderByButtons();
        moveCollectionsInMobile();
    })


    const searchModal = document.querySelector('#search-modal dialog');

    if(searchModal) {
        searchModal.addEventListener('toggle',(e) => {
            if(e.newState == 'open') {
                bodyNode.classList.add('header-background-white');
            }
        })

        searchModal.addEventListener('close',(e) => {
            // if(e.newState == 'closed') {
                bodyNode.classList.remove('header-background-white');
            // }
        })
    }

    // Open/Close Add Address

    const addAddressButton = document.querySelector('#add-address__button');
    const addAddressModal = document.querySelector('#add-address');
    const closeAddressButton = document.querySelector('#close-addresses');


    if(addAddressButton && addAddressModal && closeAddressButton) {
        addAddressButton.addEventListener('click', () => {
            addAddressModal.classList.add('show');
            bodyNode.classList.add('overflow-hidden');
        })
        closeAddressButton.addEventListener('click', () => {
            addAddressModal.classList.remove('show');
            bodyNode.classList.remove('overflow-hidden');
        })
    }

    // Open/Close Edit Address

    const editAddressForms = document.querySelectorAll('.customer-address');

    if(editAddressForms?.length > 0) {
        editAddressForms.forEach((addressForm) => {
            const buttonOpen = addressForm.querySelector('.customer-address__info .edit-address__button');
            const buttonClose = addressForm.querySelector('.edit-address__modal .close-addresses-edit');

            const editAddressModal = addressForm.querySelector('.edit-address__modal');

            if(buttonOpen && editAddressModal && buttonClose) {
                buttonOpen.addEventListener('click', () => {
                    editAddressModal.classList.add('show');
                    bodyNode.classList.add('overflow-hidden');
                })
                buttonClose.addEventListener('click', () => {
                    editAddressModal.classList.remove('show');
                    bodyNode.classList.remove('overflow-hidden');
                })
            }


        });
    }


    // Add variants to products

    async function searchProductsByTag(tagName) {
        if (typeof tagName !== 'string' || tagName.trim() === '') { // DM20260909 quando un prodotto non ha tag, la funzione restituisce immediatamente una lista vuota
        return [];
        }

        try {
            const res = await fetch(
                window.Shopify.routes.root +
                `search?resources[type]=product&resources[options][fields]=tag&resources[options][unavailable_products]=hide&q=tag:${tagName}&view=json&vs=${new Date().getTime()}`
            );
            const data = await res.text();

            if(data){
                const parser = new DOMParser();
                const parsedData = parser.parseFromString(data, "text/html");
                const findedProducts = parsedData.querySelectorAll('#ResultsList .product-grid__item');
                const matchedProducts = [];

                findedProducts.forEach((findedProduct) => {
                    const findedTag = findedProduct.getAttribute('data-tag');
                    if(findedTag == tagName) {
                        matchedProducts.push(findedProduct);
                    }
                })

                return matchedProducts;
            }
            return [];
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const productsList = document.querySelectorAll('.product-grid__item');

    if(productsList?.length > 0) {
        productsList.forEach(async (productItem) => {
            const productTitle = productItem.querySelector('.product-title__text');
            const productTag = productItem.getAttribute('data-tag');
            const productId = productItem.getAttribute('data-product-id');

            const findedProducts = await searchProductsByTag(productTag);
            let currentActive = productItem;

            if(findedProducts?.length > 1) {
                const variantWrapper = document.createElement('div');
                variantWrapper.classList = 'custom-product-variants form-group mt-1 mt-lg-3 mb-3 bg-powder-light p-2 pt-1 d-inline-block';
                variantWrapper.innerHTML = `
                    <div>
                        <h6 class="small mb-1">Formato</h6>
                        <div class="product-variant-container d-flex flex-wrap gap-2 small">
                        </div>
                    </div>
                `
                const variantContainer = variantWrapper.querySelector('.product-variant-container');

                // Create variants wrapper for finded products
                
                findedProducts.forEach(element => {
                    const findedProductTitle = element.querySelector('.product-title__text');
                    const variant = document.createElement('div');
                    const formatoLabel = element.querySelector('.product-format__label');
                    const elementId = element.getAttribute('data-product-id');
                    const isSameProduct = productId == elementId;


                    variant.classList = 'product-variant d-inline-block';
                    variant.innerHTML = `
                                        <label class="custom d-block fw-bold px-2 ${isSameProduct ? 'active' : ''}" data-product-id="${elementId}">
                                            <span class="text-lowercase">${formatoLabel?.textContent || ''}</span>
                                        </label>
                                        `
                    variantContainer.appendChild(variant);

                    // On change variant
                    variant.addEventListener('click', () => {
                        currentActive.insertAdjacentElement('afterEnd',element);
                        findedProductTitle?.insertAdjacentElement('afterEnd',variantWrapper);
                        currentActive.remove();
                        currentActive = element;

                        // Set active current variant
                        const allVariants = variantWrapper.querySelectorAll('label');
                        allVariants.forEach(variantItem => {
                            if(currentActive.getAttribute('data-product-id') == variantItem.getAttribute('data-product-id')) {
                                variantItem.classList.add('active');
                            }else{
                                variantItem.classList.remove('active');
                            }
                        });
                    })
                });


                productTitle?.insertAdjacentElement('afterEnd',variantWrapper);

            }
        })
    }

    // Add variants to single product

    async function addVariantsToSingleProduct() {
        const productSingleDetails = document.querySelector('#MainContent[data-template="product"] .product-details');
        
        if(productSingleDetails) {
            const productTag = productSingleDetails.getAttribute('data-tag');
            const productId = productSingleDetails.getAttribute('data-product-id');

            if(productTag) {
                const findedProducts = await searchProductsByTag(productTag);

                if(findedProducts?.length > 1) {
                    const productPrice = document.querySelector('product-price');
                    const variantWrapper = document.createElement('variant-picker');
                    variantWrapper.classList = 'mb-3 bg-powder-light pt-2 p-3 variant-picker spacing-style variant-picker--left';
                    variantWrapper.setAttribute('style',`--color-strikethrough-mix: #000;
                                --padding-block-start: 0px;
                                --padding-block-end: 0px;
                                --padding-inline-start: 0px;
                                --padding-inline-end: 0px;`);
                                

                    variantWrapper.innerHTML = `
                            <form class="variant-picker__form">
                                <fieldset
                                    class="variant-option variant-option--buttons variant-option--equal-width-buttons"
                                >
                                    <legend class="small mb-1">Formato</legend>
                                    <label class="">
                                        
                                    </label>
                                    <style data-shopify="">
                                        [data-option-id='template-23546126270821__main-9673041707365-formato'] {
                                            --variant-ch: 6ch;
                                        }
                                    </style>
                                </fieldset>
                            </form>
                    `
                    const variantLegend = variantWrapper.querySelector('legend');

                    // Create variants wrapper for finded products

                    findedProducts.forEach(element => {
                        const variant = document.createElement('a');
                        const formatoLabel = element.querySelector('.product-format__label');
                        const linkToProduct = element.querySelector('.product-card__link')?.getAttribute('href');
                        const isSameProduct = productId == element.getAttribute('data-product-id');

                        variant.setAttribute('href', linkToProduct || '#');
                        variant.classList = 'fw-bold px-2 variant-option__button-label';
                        variant.innerHTML = `
                                            <span class="variant-option__button-label__pill ${isSameProduct ? 'active' : ''}"></span>
                                            <span class="variant-option__button-label__text">${formatoLabel?.textContent || ''}</span>
                                            `
                        variantLegend.insertAdjacentElement('afterEnd',variant);
                    });

                    productPrice?.insertAdjacentElement('afterEnd',variantWrapper);
                }
            }
        }
    }

    addVariantsToSingleProduct();

    // Add accordion logic

    const accordionItems = document.querySelectorAll('.collection-accordion');

    if(accordionItems?.length > 0) {
        accordionItems.forEach((accordion) => {
            const toggler = accordion.querySelector('.accordion-toggler');

            if(toggler) {
                toggler.addEventListener('click' , (e) => {
                    accordion.classList.toggle('active');
                })
            }
        })
    }

    // Move newsletter form

    const sibForm = document.querySelector('.sib-form');
    const footerNewsletter = document.querySelector('.footer-newsletter h2');

    if(sibForm && footerNewsletter) {
        footerNewsletter.insertAdjacentElement('afterend',sibForm);
    }


    // Add actual year

    const currentYearElements = document.querySelector('.footer-copyright strong');

    if (currentYearElements) {
        const currentYear = new Date().getFullYear();
        currentYearElements.textContent = currentYear;
    }

    // Copy language to header-top

    // Language selector

    const languageSelector = document.querySelector('.language-selector__button');
    const languageSelectorModal = document.querySelector('.language-selector__modal');
    const languageSelectorModalInner = document.querySelector(
        '.language-selector__modal .language-selector__modal-translate'
    );
    const languageSelectorSelect = document.querySelector('.gt_switcher')?.parentElement;
    const languageSelectorClose = document.querySelector('.language-selector__modal-close');
    const languageSelectorSubmit = document.querySelector('.language-selector__modal .btn[type="submit"]');

    if (languageSelectorModalInner && languageSelectorSelect) {
        languageSelectorModalInner.innerHTML = '';
        languageSelectorModalInner.appendChild(languageSelectorSelect);
    }

    if (languageSelectorClose && languageSelectorModal && languageSelectorSubmit) {
        function closeLanguageModal() {
            languageSelectorModal.classList.remove('active');
            bodyNode.classList.remove('bg-white-menu');
        }
        languageSelectorClose.addEventListener('click', closeLanguageModal);
        languageSelectorSubmit.addEventListener('click', closeLanguageModal);
    }

    if (languageSelector && languageSelectorModal) {
        languageSelector.addEventListener('click', () => {
            if (languageSelectorModal.classList.contains('active')) {
                languageSelectorModal.classList.remove('active');
                bodyNode.classList.remove('bg-white-menu');
            } else {
                languageSelectorModal.classList.add('active');
                bodyNode.classList.add('bg-white-menu');
            }
        });
    }


    const langsModal = document.querySelectorAll('.language-selector__lang');
    const langWrapper = document.querySelector('.gt_switcher');

    if (langsModal?.length  > 0 && langWrapper) {
        const updateLang = () => {
            setTimeout(() => {
                const currentLang = document.querySelector('.nturl.gt_current');
                if (currentLang) {
                    langsModal.forEach((langModal) => {
                        langModal.innerHTML = currentLang.textContent.trim();
                    })
                    moveLanguageToMobile();
                }

            }, 1000);
        };

        updateLang();

        const observer = new MutationObserver(updateLang);

        observer.observe(langWrapper, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

 
    function hasGTranslateCookie() {
        return document.cookie.includes('googtrans=');
    }

    function setItalianIfNoCookie() {
        if (hasGTranslateCookie()) return;
        const realLangOption = document.querySelector(`#header-group a[data-gt-lang="it"]`);
        if(realLangOption) {
            realLangOption.click();
        }


    }

    setItalianIfNoCookie();

})

 




